<template>
    <div class="paging_wrap">
        <div class="dataTables_paginate paging_full_numbers" id="list_paginate">
            <ul class="pagination">
                <li class="paginate_button page-item first disabled" id="list_first" @click="fnPaging(1)">
                    <router-link to="#" aria-controls="list" data-dt-idx="0" tabindex="0" class="page-link">
                        <img src="@/assets/common/pg_first_ico.png" alt="" />
                    </router-link>
                </li>
                <li class="paginate_button page-item previous disabled" id="list_previous"
                    @click="currentPage > 1 ? fnPaging(currentPage - 1) : ''">
                    <router-link to="#" aria-controls="list" data-dt-idx="1" tabindex="0" class="page-link">
                        <img src="@/assets/common/pg_prev_ico.png" alt="" />
                    </router-link>
                </li>
                <template v-if="currentPage <= 3">
                    <li v-for="index in Math.min(paging, 5)" :key="index" @click="fnPaging(index)"
                        class="paginate_button page-item" :class="[index === currentPage ? 'active' : '']">
                        {{ index }}
                    </li>
                </template>
                <template v-else-if="currentPage >= paging - 2">
                    <li v-for="index in [paging - 4, paging - 3, paging - 2, paging - 1, paging]" :key="index"
                        @click="fnPaging(index)" class="paginate_button page-item"
                        :class="[index === currentPage ? 'active' : '']">
                        {{ index }}
                    </li>
                </template>
                <template v-else>
                    <li v-for="offset in [-2, -1, 0, 1, 2]" :key="currentPage + offset"
                        @click="fnPaging(currentPage + offset)" class="paginate_button page-item"
                        :class="[currentPage + offset === currentPage ? 'active' : '']">
                        {{ currentPage + offset }}
                    </li>
                </template>
                <li class="paginate_button page-item next" id="list_next"
                    @click="currentPage < paging ? fnPaging(currentPage + 1) : ''">
                    <router-link to="#" aria-controls="list" data-dt-idx="4" tabindex="0" class="page-link">
                        <img src="@/assets/common/pg_next_ico.png" alt="" />
                    </router-link>
                </li>
                <li class="paginate_button page-item last" id="list_last" @click="fnPaging(paging)">
                    <router-link to="#" aria-controls="list" data-dt-idx="5" tabindex="0" class="page-link">
                        <img src="@/assets/common/pg_end_ico.png" alt="" />
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>
<script lang="ts" config>
import { reactive, computed } from "@/BaseComponent";
export default {
    props: ["currentPage", "totalLength", "perPage"],
    emits: ["onPaging",],

    setup(props: any, emits: any) {
        const state = reactive({
            currentPage: 1 as number,
            totalLength: 1 as number,
            perPage: 1 as number,
        });
        const paging = computed(() => {
            if (Math.ceil(props.totalLength / props.perPage) === 0) {
                return 1;
            }
            return Math.ceil(props.totalLength / props.perPage);
        });

        const fnPaging = (index: number) => {
            emits.emit("onPaging", index);
        };

        return {
            props,
            state,
            paging,
            fnPaging,
        };
    },
};
</script>